import moment from "moment";
import { Moment } from "moment";

export const TYPEABLE_DATE_DISPLAY_FORMAT = "DD/MM/YYYY";
export const TYPEABLE_DATE_MAX_LENGTH = 10;
export const TYPEABLE_DATE_MIN_YEAR = 1900;
export const TYPEABLE_DATE_MAX_YEAR = 3000;
export const TYPEABLE_DATE_TWO_DIGIT_YEAR_SPLIT = 50;

export function parseTypedDate(raw: string | null | undefined): Moment | null {
  if (raw == null) return null;
  const trimmed = String(raw).trim();
  if (!trimmed) return null;

  const digits = trimmed.replace(/[-/.]/g, "");
  if (!/^\d+$/.test(digits)) return null;
  if (digits.length !== 6 && digits.length !== 8) return null;

  const day = Number(digits.slice(0, 2));
  const month = Number(digits.slice(2, 4));
  const yearPart = digits.slice(4);

  let year: number;
  if (yearPart.length === 4) {
    year = Number(yearPart);
  } else {
    const yy = Number(yearPart);
    year = yy <= TYPEABLE_DATE_TWO_DIGIT_YEAR_SPLIT ? 2000 + yy : 1900 + yy;
  }

  if (year < TYPEABLE_DATE_MIN_YEAR || year > TYPEABLE_DATE_MAX_YEAR) return null;

  const m = moment([year, month - 1, day]);
  return m.isValid() && m.year() === year && m.month() === month - 1 && m.date() === day ? m : null;
}
